// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TVkd","colBig":"styles_colBig__13AZ7","colSmall":"styles_colSmall__mSy5C","shopifyNameWrapper":"styles_shopifyNameWrapper__1uicx"};